import React from 'react'
import styled from 'styled-components'

export default function BadgeSecondary(props){
	const {
    icon, 
    text, 
    textSecondary,
    textStatus,
    bgColor = 'gc-light-blue-dark', 
    color = 'gc-dark-blue',
    backyouIcon, // left, right
    tooltip, 
    tooltipText,
    statusPill = '',
    className = '',
    hover = false,
    children
  } = props

  let backyouClass = '';
  if(backyouIcon == 'left'){backyouClass = ' backyou-left'}
  if(backyouIcon == 'right'){backyouClass = ' backyou-right'}

	return (
		<Badge 
      className={className + " badge " + (hover && "badge-hover ") + "text-gc-dark-blue d-inline-flex align-items-center m-0 js-tooltip badge-" + bgColor + ' ' + 'text-' + color + ' ' + backyouClass}
      data-toggle={tooltip ? "tooltip" : ""} 
      data-placement="bottom" 
      title={tooltipText} 
    >
      {statusPill != '' && <span className={"mr-1 pill-status pill-status-" + statusPill}> </span>}
      {icon && <span className={text != '' ? "mr-1" : ''}>{icon}</span>}
      {children ? children : text}
      {textSecondary && <span className="ml-1">| {textSecondary}</span>}
      {textStatus != '' && <span className="ml-1">{textStatus}</span>}
    </Badge>
	);
}

const Badge = styled.span`
  font-size: .8rem!important;
  transition: .3s;

  .pill-status {
    padding: 0;
    height: 10px;
    width: 10px;
    border-radius: 50px;
  }
  .pill-status-red {
    background-color: #DA1923;
  }
  .pill-status-green {
    background-color: #2ca000;
  }
  .pill-status-dark-blue {
    background-color: #004753;
  }
  .pill-status-orange {
    background-color: #ff832b;
  }
  .pill-status-gray {
    background-color: #8d8d8d;
  }

  &.badge-hover {
    &:hover {
      opacity: .6!important;
      display: none;
    }
  }
`;